import type { DebugTabProps } from './types';
import { CopyButton } from './CopyButton';
import './dev-tools.css';

export function DebugTab({ entries }: DebugTabProps) {
  const handleCopyAll = () => {
    const text = entries.map((e) => `${e.label}: ${e.value}`).join('\n');
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="caddietw-flex caddietw-flex-col caddietw-gap-3">
      <div className="caddietw-flex caddietw-items-center caddietw-justify-between">
        <span className="devtools-section-heading">Runtime Info</span>
        <button
          type="button"
          onClick={handleCopyAll}
          className="caddietw-text-xs caddietw-text-blue-500 caddietw-bg-transparent caddietw-border-0 caddietw-cursor-pointer hover:caddietw-text-blue-700 caddietw-transition-colors caddietw-underline"
        >
          Copy all
        </button>
      </div>
      <div className="caddietw-border caddietw-border-gray-200 caddietw-rounded-lg caddietw-divide-y caddietw-divide-gray-100">
        {entries.map((entry) => (
          <div
            key={entry.label}
            className="caddietw-flex caddietw-items-center caddietw-justify-between caddietw-py-2 caddietw-px-3 caddietw-gap-3"
          >
            <span className="caddietw-text-xs caddietw-text-gray-500 caddietw-flex-shrink-0">
              {entry.label}
            </span>
            <div className="caddietw-flex caddietw-items-center caddietw-gap-1 caddietw-min-w-0">
              <span
                className="caddietw-text-xs caddietw-font-mono caddietw-text-gray-900 caddietw-truncate"
                title={entry.value}
              >
                {entry.value}
              </span>
              <CopyButton value={entry.value} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
